import React from "react";
import ToolTip from "../ToolTip";
import CheckIcon from '../../../../images/icons/checkmark_final.png';
import getPercentileColor from "../../util/getPercentileColor";
import cx from "classnames";

import "./index.scss";
import ERSSSubSkillGroupContainer from "./ERSSSubSkillGroupContainer";
import ERSSCurrentIcon from "./ERSSCurrentIcon";

function CellGroup(props) {
  const { isDefaultCurriculum, module, subSkills, domain, skillArea, studentId, height = 40, displayErssStatus, currentSkillCount = 0, maxWidthPercentageForEachModuleSubSkills, allSubSkillGroupsForEachModuleAcrossDomains } = props;  

  const renderContent = (subSkills) => {
    return subSkills.map((subSkill, i) => {

      if(subSkill.blank) {
        return <div className="blank-cell" key={i} style={{height}}></div>
      }

      const pacing = subSkill.mastery.pacing;
      const cellColor = getPercentileColor(pacing);
      const { url, taken, current } = subSkill;
      const skillIcon = (isDefaultCurriculum && displayErssStatus && taken) ? <img className="check-icon" src={CheckIcon} alt="check" /> : null;
      const subSkillData = { ...subSkill, domain, skillArea, studentId };
  
      const wrapperClassName = cx({
        "cell-wrapper": true,
        clickable: url || props.setSkillModalData,
      });
  
      const cellClassName = cx({
        "single-cell": true,
        "in-progress-erss-activity": displayErssStatus && current,
        [subSkill.sequence]: true,
      });
  
      let width = 100 / subSkills.length;
  
      return (
        <ToolTip data={subSkillData} key={i}>
          <div className={wrapperClassName} style={{ width: `${width}%` }}>
            <div
              onClick={() => {
                if (props.setSkillModalData)
                  props.setSkillModalData(subSkillData);
                else if (url) window.open(url);
              }}
              className={cellClassName}
              style={{ background: cellColor, height }}
            >
              {skillIcon}
            </div>
          </div>
        </ToolTip>
      );
    });
  }

  const renderWithGrouping = (subSkillsGroupedBySubModuleNameWithBlanks) => {

    return subSkillsGroupedBySubModuleNameWithBlanks.map((subSkill, i) => {
      const skillKey = Object.keys(subSkill)[0];
      const isCurrent = subSkill[skillKey].some(subSkill => subSkill.current);
      const width = maxWidthPercentageForEachModuleSubSkills[skillKey]?.pixelWidth;
      return <ERSSSubSkillGroupContainer
              top={<div className={`sub-skill-group group-${skillKey}`} key={i} style={{width: `${width}px`, display: "flex"}}>
                  {renderContent(subSkillsGroupedBySubModuleNameWithBlanks[i][skillKey])}
                </div>}
              bottom={isCurrent ? <ERSSCurrentIcon/> : null}
              key={i}
            />
    })
  }

  // group the subskills by their last character into an array where each element is an array of subskills with the same last character
  const subSkillsGroupedBySubModuleName = subSkills.reduce((acc, subSkill) => {
    const subModuleName = subSkill?.sequence
    if(!subModuleName) return acc;
    if(!acc[subModuleName]) acc[subModuleName] = [];
    acc[subModuleName].push(subSkill);
    return acc;
  }, []);

  // if subSkills has a sequence that is not in subSkillGroups, then add a blank cell
  let subSkillsGroupedBySubModuleNameWithBlanks = {}
  if(allSubSkillGroupsForEachModuleAcrossDomains){
    const allSubSkillsInCurrentModule = allSubSkillGroupsForEachModuleAcrossDomains[module].groups
    subSkillsGroupedBySubModuleNameWithBlanks = allSubSkillsInCurrentModule.map(name => {
      return {
        [name]: subSkillsGroupedBySubModuleName[name] || [{blank: true, sequence: name}]
      }
    });
  }

  if(Object.keys(subSkillsGroupedBySubModuleNameWithBlanks).length > 1 && isDefaultCurriculum && !module.includes('Wilson F')) {
    return renderWithGrouping(subSkillsGroupedBySubModuleNameWithBlanks);
  }

  return renderContent(subSkills);
}

export default React.memo(CellGroup);
